<!-- 部门管理 -->
<template>
  <BaseContainer class="tab-detart-manage" :loading="false" :isHasPageFt="false">
     <template slot='hd'>
        <div class="hd-title-box" style="padding-left: 20px;">
          <p class="hd-title-box-name"> 部门管理 </p>
          <p class="hd-title-box-subName" style="line-height: 1.5">
            当前有 {{total}} 个部门
          </p>
        </div>
       <el-form :inline="true">
          <el-form-item>
              <el-input  v-model="searchText"  placeholder="部门 / 管理员" style="width:200px;" clearable   @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>

          <el-form-item>
              <el-button type="primary" size="medium" @click="getList(1)">查询</el-button>
              <el-button type="primary" size="medium" plain icon="el-icon-plus" @click="addForm">新 增</el-button>
          </el-form-item>      
       </el-form>
     </template>

     <template slot="main">
        <el-table :data="dataList" highlight-current-row  @selection-change="handerSectionChange" @row-click="handerRowClick" style="width: 100%;" ref="companyTabRef" v-loading="listLoading">
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column type="index" :index="indexMethod" label="序号" width="80">
              <template slot-scope="scope">
                  <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
              </template>
          </el-table-column>

          <el-table-column prop="deptname" min-width="180" label="部门名称"  show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.deptname || '-'}}
            </template>
          </el-table-column>
            
          <el-table-column prop="deptManagerName" min-width="180" label="部门管理员"  show-overflow-tooltip>
             <template slot-scope="scope">
              {{ scope.row.deptManagerName || '-'}}
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="110">
              <template slot-scope="scope">
                <span class="operate">
                    <!-- <el-tooltip effect="dark" content="详情" placement="top">
                      <span class="dnnfont iconfile-search"  @click="handleDetail(scope.$index, scope.row)"></span>
                    </el-tooltip> -->
                   
                     <!-- <el-tooltip effect="dark" content="编辑" placement="top" >
                          <span class="dnnfont iconEdit"  @click="handleEdit(scope.$index, scope.row)"></span>
                     </el-tooltip> -->
                    
                      
                      <!-- 1、部门下没人 -->
                      <!-- <el-tooltip effect="dark" content="删除" placement="top" v-if="scope.row.hasUser !=1">
                        <span class="dnnfont icondelete"  @click="handleDel(scope.$index, scope.row)"></span>
                      </el-tooltip> -->

                      <el-button type="primary" plain size="small"  @click="handleDetail(scope.$index, scope.row)">查看</el-button>
                      <el-button type="danger" plain size="small"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button type="danger" :disabled="scope.row.hasUser ==1" plain size="small"  @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </span>
              </template>
            </el-table-column>  
        </el-table>

          <el-col :span="24" class="toolbar" style="position: relative">
          <!-- <div class="operate-box" style="float: left">
            <el-button type="danger"  :disabled="selectedUserId.length == 0" size="small" @click="getList(1)">批量删除</el-button>
          </div> -->

          <el-pagination  
            layout="sizes, prev, pager, next"
            :page-sizes="[10, 20, 30, 50,100]"
            :current-page="pageNumber" 
            :page-size="pageSize" 
            :total="total" 
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            style="float:right;">
          </el-pagination>
        </el-col>

        <ModalForm :visible.sync="visible" :mode="mode" :processDetail="processDetail" :companymanageid="companymanageid" :token="token" v-if="visible"  @getList="getList"/>
        <ModalFormView :visible.sync="visibleView" :processDetail="processDetail" v-if="visibleView" />
            
     </template>

     <template slot='ft'>
     
     </template>
  </BaseContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import {  API_Company, API__account } from '@/api/index.js'
import BaseContainer from '@/components/BaseContainer'
import ModalForm from './ModalForm.vue'
import ModalFormView from './ModalFormView.vue'
import  utils  from '@/utils/index'
export default {
  props: {
    companymanageid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      listLoading: false,
      dataList: [],
      
      // 分页信息
      pageNumber:1,
      pageSize: 10,
      total:0,
      token: '',

      visible: false,
      visibleView: false,
      mode: 'save',

      searchText: '',
      selectedUserId: [],

      processDetail: null,
    };
  },

  components: {
    BaseContainer,
    ModalForm,
    ModalFormView,
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },

  created() {
    this.getCookie()
    this.getList();
  },

  methods: {
    
    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
        }
      }
    },

    getList() {
      this.listLoading = true;
      let data = {
        token: this.token,
        companyid: this.companymanageid,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        searchText: this.searchText
      }
      API_Company.getDepartList(data).then(res => {
        if(res.data.code == 200) {
          let data = res.data.data;
          this.dataList = data.list;
          this.total = data.totalRow
        }else {
          if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch( err => {
         this.listLoading = false;
      })
    },


    handerSectionChange(data, column, event) {
       console.log("handerSectionChange==", data)
       this.selectedUserId = data.length > 0?
                             data.map(item => item.id): []

    },
    
    // 单击行
    handerRowClick(row, column, event) {
      // console.log("handerRowClickrow==", row, event.target)
      if(event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },
   
    
    // 新增
    addForm() {
      this.visible = true;
      this.mode = 'save'
    },
    
    // 删除
    handleDel(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
        }
        API_Company.delDepart(param)
        .then((res) =>{
          if(res.data.code == 200){
            this.$message({ message: '删除成功', type: 'success' });
            this.getList();
          }else{
            this.$message.error('删除失败');
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      }).catch(err =>{
      });
    },

    handleEdit(index,row) {
      this.processDetail = row
      this.visible = true;
      this.mode = 'update'
    },
    
    // 详情
    handleDetail(index,row) {
      this.processDetail = row
      this.visibleView = true;
    },

    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},

    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*this.pageSize;
    },


  }
}

</script>
<style lang='scss'>
.base-container-bd {
  overflow: hidden !important;
  .content-hd {
    height: 120px !important;
  }
}
.base-container {
  padding: 14px 0 !important;
}
.tab-detart-manage, .base-container .base-container-ft {
  background-color: transparent !important;
}
.hd-title-box {
    margin: 0;
    margin-bottom: 15px;
    width: 100%;
  }

.hd-title-box-name{
  margin: 0;
  font-size:20px;
  color:#666;
  font-weight:bold;
}
.hd-title-box-subName{
  margin: 0;
  font-size:14px;
  color:#666;
  font-weight:normal;
}
</style>


// WEBPACK FOOTER //
// index.vue?ab657fc2